module.exports = __webpack_public_path__ + "static/img/nav.16df265.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nav.png
// module id = KysW
// module chunks = 65